import { GeneralModel } from "./general.model";
import { District } from "./district.model";
import { Province } from "./province.model";

export class Ward extends GeneralModel {
    districtId: number;
    district: District;
    province: Province;
    vseOracleCode: string;
    kmNumber:number;
    isRemote:boolean;
    provinceId: number;
    isMerged: boolean;
    mergedToWardId: number;
    note: string;
    isMultipleRouting: boolean;
    isApprove: boolean;
    isCenter: boolean;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/ward.model.ts